<template>
  <kst-container class="kst-salesrecap-details">
    <kst-form
      :failureInit="failureInit"
      :hide-body="!!formWarnings"
      :hide-footer="!!formWarnings"
      :loading="isLoading"
      :title="title"
      :warnings="formWarnings"
    >
      <template #top-right>
        <Action :data="data"/>
      </template>

      <b-tabs v-model="activeTab" size="is-medium" type="is-boxed">
        <b-tab-item :label="tabs.Details">
          <Details :data="data"/>
        </b-tab-item>
        <b-tab-item :label="tabs.InvoiceList">
          <InvoiceRelated :failureList="failureInit" :items="data.InvoiceList" :isListLoading="isLoading"/>
        </b-tab-item>
      </b-tabs>
    </kst-form>
  </kst-container>
</template>

<script>
import AxiosMixin from "@/mixins/AxiosMixin.js";
import RouterMixin from "@/mixins/RouterMixin.js";
import Info from "../SalesRecapInfo.js";
import Services from "../SalesRecapServices.js";
import Model from "../SalesRecapModel.js";

import Action from "./SalesRecapDetails_Action";
import Details from "./SalesRecapDetails_Details";
import InvoiceRelated from "@/components/Invoice/RelatedSalesRecap/InvoiceRelatedList";

export default {
  mixins: [AxiosMixin, RouterMixin],
  components: {
    Action,
    Details,
    InvoiceRelated
  },
  data: () => ({
    data: {},
    isLoading: false,
    // tabs
    activeTab: 0,
    tabs: {
      Details: Info.Tabs.Details,
      InvoiceList: Info.Tabs.InvoiceList
    },
    // error
    formWarnings: null,
    failureInit: null,
  }),
  computed: {
    title() {
      return this.$route.meta.title;
    }
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      const id = this.getUrlParam(this.$kst.Enum.Param.ID);
      this.formWarnings = null;

      if (!id) {
        this.formWarnings = [Info.Message.Details_ParamIncomplete];
        return;
      }

      this.data = {};

      this.initLoad(id);
    },
    initLoad(id) {
      this.isLoading = true;
      this.failureInit = null;

      this.loadDetails(id);
    },
    initLoad_End() {
      this.isLoading = false;
      this.isListLoading = false;
    },

    loadDetails(id) {
      const options = { withinvoice: 1 };
      const config = Services.getSalesRecapDetails(id, options);
      this.runAxios(config, null, this.loadDetails_Success, this.loadDetails_Error);
    },
    loadDetails_Success(data) {
      Model.setDetails(data)
      this.data = data;
      
      this.initLoad_End();
    },
    loadDetails_Error(message) {
      this.failureInit = message;
      this.initLoad_End();
    }
  }
}
</script>